import { useMemo } from "react";

import { Modal as SharedModal } from "@sorcery/ui";

import { CardGalleryModal } from "~/components/modals/CardGalleryModal";
import { ContentModal } from "~/components/modals/ContentModal";
import { ModalTypeEnum, useModal } from "~/providers/ModalProvider";

export const ModalDecorator = () => {
  const { closeModal, isModalOpen, modalType, props } = useModal();
  const modalResolver = () => {
    switch (modalType) {
      case ModalTypeEnum.CARDGALLERY:
        // biome-ignore lint/style/noNonNullAssertion: <explanation>
        return <CardGalleryModal index={props!.index!} cards={props!.cards!} />;
      case ModalTypeEnum.CONTENT:
        return <ContentModal>{props?.children}</ContentModal>;
      default:
        return null;
    }
  };

  const isGallery = useMemo(() => modalType === ModalTypeEnum.CARDGALLERY, [modalType]);

  const isBigAsFuck = useMemo(() => modalType === ModalTypeEnum.CONTENT, [modalType]);

  return (
    <SharedModal
      renderContent={modalResolver}
      closeModal={closeModal}
      isModalOpen={isModalOpen}
      isGallery={isGallery}
      isBigAsFuck={isBigAsFuck}
    />
  );
};
